/* import __COLOCATED_TEMPLATE__ from './category-title-before.hbs'; */
import Component from "@ember/component";
export default Component.extend({
  tagName: "",
});
